export default {
  privateMessageReplies: [],
  processing: false,
  error: null,
  success: null,
}



